<template>
  <div class="stat-card">
    <div>
      <p class="stat-label">{{ label }}</p>
      <p class="stat-value">{{ value }}</p>
    </div>
    <div class="stat-icon" :style="{ background: color + '18' }">{{ icon }}</div>
  </div>
</template>

<script>
export default {
  name: 'StatCard',
  props: {
    label: { type: String, required: true },
    value: { type: Number, required: true },
    icon:  { type: String, required: true },
    color: { type: String, required: true },
  },
};
</script>

<style scoped>
.stat-card {
  background: #fff;
  border-radius: 14px;
  padding: 16px 20px;
  border: 1px solid #E8EBF5;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.stat-label {
  font-size: 11px;
  color: #9DA5C0;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: .06em;
  margin: 0;
}
.stat-value {
  font-size: 28px;
  font-weight: 700;
  color: #1a1a2e;
  margin: 4px 0 0;
}
.stat-icon {
  width: 44px;
  height: 44px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 20px;
  flex-shrink: 0;
}
</style>